/* ==============================
   CONSTANTS & CONFIG
============================== */

const TANKSIZE = 1;
let oldTankSize = TANKSIZE;
let PRODUCTS = {};
let TARGET_EC = {};

const AUTO_HIDE_WEEKS = [
  "week2", // Seedlings W2
  "week6", // Veg W4
  "week12", // Flower W6
  "week13", // Flower W7
  "week14", // Flower W8
];
const START_FIXED_WEEKS = {
    seedlings: {
      "week1": 4.0,
      "week2": 4.0
    }
  };
const START_FEED_CONDUCTIVITY = {
  hydro: {
    Grow_A: { start: 1 },
    Grow_B: { start: 1 },
    Bloom_A: { start: 0 },
    Bloom_B: { start: 0 },
  },

  terra_all_mix: {
    Grow_A: { start: 1 },
    Grow_B: { start: 1 },
    Bloom_A: { start: 0 },
    Bloom_B: { start: 0 },
  },

  // Coco already works — leave it untouched
};

const BASE_FEEDS = {
  coco: ["Samurai Coco A", "Samurai Coco B"],
  coco_auto: ["Samurai Coco A", "Samurai Coco B"],
  hydro: [
    "Samurai Hydro Grow SW A",
    "Samurai Hydro Grow SW B",
    "Samurai Hydro Bloom SW A",
    "Samurai Hydro Bloom SW B",
  ],
  hydro_auto: [
    "Samurai Hydro Grow SW A",
    "Samurai Hydro Grow SW B",
    "Samurai Hydro Bloom SW A",
    "Samurai Hydro Bloom SW B",
  ],
  terra_all_mix: ["Samurai Terra Grow", "Samurai Terra Bloom"],
  terra_auto_all_mix: ["Samurai Terra Grow", "Samurai Terra Bloom"],
};
const PHASE_BASED_NUTRIENTS = [
  "hydro",
  "hydro_auto",
  "terra_auto_all_mix",
  "terra_all_mix",
];

const PHASE_PRODUCTS = {
  cuttings: [
    "katana_roots",
    "Samurai Hydro Grow A",
    "Samurai Hydro Grow B",
    "Samurai Hydro Bloom A",
    "Samurai Hydro Bloom B",
    "Samurai Terra Grow",
    "Samurai Terra Bloom",
  ],
  vegetative: ["zenzym", "silicon", "calmag"],
  flowering: [
    "sumo_active_boost",
    // "sumo_active_foliar",
    "geisha_foliar",
    "pk_warrior",
    "dragon_force",
  ],
};
const BASE_FEED_CONDUCTIVITY = {
  coco: { A: 0.25, B: 0.25 },
  coco_auto: { A: 0.25, B: 0.25 },

  hydro: {
    Grow_A: 0.35,
    Grow_B: 0.35,
    Bloom_A: 0.25,
    Bloom_B: 0.25,
  },
  hydro_auto: {
    Grow_A: 0.35,
    Grow_B: 0.35,
    Bloom_A: 0.25,
    Bloom_B: 0.25,
  },
  terra_all_mix: { Grow_A: 0.4, Bloom_A: 0.34 },
  terra_auto_all_mix: { Grow_A: 0.4, Bloom_A: 0.34 },
};

/* PRODUCTS */
// const NUTRIENT_LINES = {
//   coco: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1.2, week2: 1.2, week3: 1.5, week4: 1.5 },
//         standard: { week1: 1.5, week2: 1.5, week3: 1.8, week4: 1.8 },
//         heavy: { week1: 1.8, week2: 1.8, week3: 2.1, week4: 2.1 },
//       },
//       flowering: {
//         light: {
//           week1: 1.7,
//           week2: 1.7,
//           week3: 1.7,
//           week4: 1.8,
//           week5: 1.2,
//           week6: 1.2,
//           week7: 1.2,
//           week8: null,
//         },
//         standard: {
//           week1: 2,
//           week2: 2,
//           week3: 2,
//           week4: 2.1,
//           week5: 1.5,
//           week6: 1.5,
//           week7: 1.5,
//           week8: null,
//         },
//         heavy: {
//           week1: 2.3,
//           week2: 2.3,
//           week3: 2.3,
//           week4: 2.4,
//           week5: 1.8,
//           week6: 1.8,
//           week7: 1.8,
//           week8: null,
//         },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2, week4: 0.2 },
//         floweringGrowth: {
//           week1: 0.2,
//           week2: 0.2,
//           week3: 0.2,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5, week4: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//           week6: 2.5,
//           week7: 2.5,
//           week8: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//           week6: 2.0,
//           week7: 2.0,
//           week8: 2.0,
//         },
//       },
//       sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: null, week1: null },
//         floweringGrowth: {
//           week1: null,
//           week2: 2.0,
//           week3: null,
//           week4: 2.0,
//           week5: null,
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {
//           week1: null,
//           week2: 'RTU',
//           week3: null,
//           week4: 'RTU'
//         },
//         floweringGrowth: {
//           week1: null,
//           week2: 'RTU',
//           week3: null,
//           week4: 'RTU',
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: 1.0,
//           week5: 0.5,
//           week6: 0.5,
//           week7: 0.5,
//           week8: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: 4,
//         },
//       },
//     },
//   },
//   coco_auto: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1, week2: 1.2, week3: 1.2, week4: null },
//         standard: { week1: 1.2, week2: 1.4, week3: 1.4, week4: null },
//         heavy: { week1: 1.4, week2: 1.6, week3: 1.6, week4: null },
//       },
//       flowering: {
//         light: { week1: 1.4, week2: 1.6, week3: 1.2, week4: 1.2, week5: null },
//         standard: {
//           week1: 1.6,
//           week2: 1.8,
//           week3: 1.4,
//           week4: 1.4,
//           week5: null,
//         },
//         heavy: { week1: 1.8, week2: 2, week3: 1.6, week4: 1.6, week5: null },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2 },
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//         },
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: { week1: 1, week2: 1, week3: 1, week4: 1, week5: null },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: { week1: 1, week2: 1, week3: 1, week4: 1, week5: null },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: null, week3: null},
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//         },
//       },
//       sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: 2.0, week3: null },
//         floweringGrowth: {
//           week1: 2.0,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {
//           week1: null,
//           week2: 'RTU',
//           week3: null
//         },
//         floweringGrowth: {
//           week1: 'RTU',
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 0.5,
//           week2: 0.5,
//           week3: 0.5,
//           week4: 0.5,
//           week5: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: 4
//         },
//       },
//     },
//   },
//   hydro: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1.2, week2: 1.2, week3: 1.5, week4: 1.5 },
//         standard: { week1: 1.5, week2: 1.5, week3: 1.8, week4: 1.8 },
//         heavy: { week1: 1.8, week2: 1.8, week3: 2.1, week4: 2.1 },
//       },
//       flowering: {
//         light: {
//           week1: 1.7,
//           week2: 1.7,
//           week3: 1.7,
//           week4: 1.8,
//           week5: 1.2,
//           week6: 1.2,
//           week7: 1.2,
//           week8: null,
//         },
//         standard: {
//           week1: 1.9,
//           week2: 1.9,
//           week3: 1.9,
//           week4: 2,
//           week5: 1.5,
//           week6: 1.5,
//           week7: 1.5,
//           week8: null,
//         },
//         heavy: {
//           week1: 2.1,
//           week2: 2.1,
//           week3: 2.1,
//           week4: 2.2,
//           week5: 1.8,
//           week6: 1.8,
//           week7: 1.8,
//           week8: null,
//         },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2, week4: 0.2 },
//         floweringGrowth: {
//           week1: 0.2,
//           week2: 0.2,
//           week3: 0.2,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5, week4: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//           week6: 2.5,
//           week7: 2.5,
//           week8: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//           week6: 2.0,
//           week7: 2.0,
//           week8: 2.0,
//         },
//       },
//       sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: null, week1: null },
//         floweringGrowth: {
//           week1: null,
//           week2: 2.0,
//           week3: null,
//           week4: 2.0,
//           week5: null,
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//         },
//         floweringGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: 1.0,
//           week5: 0.5,
//           week6: 0.5,
//           week7: 0.5,
//           week8: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: 4,
//         },
//       },
//     },
//   },
//   hydro_auto: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1, week2: 1.2, week3: 1.2 },
//         standard: { week1: 1.2, week2: 1.4, week3: 1.4 },
//         heavy: { week1: 1.4, week2: 1.6, week3: 1.6 },
//       },
//       flowering: {
//         light: {
//           week1: 1.4,
//           week2: 1.6,
//           week3: 1.2,
//           week4: 1.2,
//         },
//         standard: {
//           week1: 1.6,
//           week2: 1.8,
//           week3: 1.4,
//           week4: 1.4,
//         },
//         heavy: {
//           week1: 1.8,
//           week2: 2,
//           week3: 1.6,
//           week4: 1.6,
//         },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2 },
//         floweringGrowth: {},
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: null,
//         },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: null,
//         },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: null, week3: null },
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//         },
//       },
//      sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: 2.0, week3: null, week4: null },
//         floweringGrowth: {
//           week1: 2.0,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//         },
//         floweringGrowth: {
//           week1: "RTU",
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 0.5,
//           week2: 0.5,
//           week3: 0.5,
//           week4: 0.5,
//           week5: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: 4,
//         },
//       },
//     },
//   },
//   terra_all_mix: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1.2, week2: 1.2, week3: 1.5, week4: 1.5 },
//         standard: { week1: 1.4, week2: 1.4, week3: 1.7, week4: 1.7 },
//         heavy: { week1: 1.6, week2: 1.6, week3: 1.9, week4: 1.9 },
//       },
//       flowering: {
//         light: {
//           week1: 1.7,
//           week2: 1.7,
//           week3: 1.7,
//           week4: 1.8,
//           week5: 1.2,
//           week6: 1.2,
//           week7: 1.2,
//           week8: null,
//         },
//         standard: {
//           week1: 1.9,
//           week2: 1.9,
//           week3: 1.9,
//           week4: 2,
//           week5: 1.5,
//           week6: 1.5,
//           week7: 1.5,
//           week8: null,
//         },
//         heavy: {
//           week1: 2.1,
//           week2: 2.1,
//           week3: 2.1,
//           week4: 2.2,
//           week5: 1.8,
//           week6: 1.8,
//           week7: 1.8,
//           week8: null,
//         },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2, week4: 0.2 },
//         floweringGrowth: {
//           week1: 0.2,
//           week2: 0.2,
//           week3: 0.2,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5, week4: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//           week6: 2.5,
//           week7: 2.5,
//           week8: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1, week4: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: 1,
//           week6: 1,
//           week7: 1,
//           week8: null,
//         },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//           week6: 2.0,
//           week7: 2.0,
//           week8: 2.0,
//         },
//       },
//       sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: 2.0,
//           week3: null,
//           week4: 2.0,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//           vegetativeGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//         },
//         floweringGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: 1.0,
//           week5: 0.5,
//           week6: 0.5,
//           week7: 0.5,
//           week8: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: 4,
//         },
//       },
//     },
//   },
//   terra_auto_all_mix: {
//     TARGET_EC: {
//       vegetative: {
//         light: { week1: 1, week2: 1, week3: 1.2 },
//         standard: { week1: 1.2, week2: 1.2, week3: 1.4 },
//         heavy: { week1: 1.4, week2: 1.4, week3: 1.6 },
//       },
//       flowering: {
//         light: {
//           week1: 1.4,
//           week2: 1.6,
//           week3: 1.2,
//           week4: 1.2,
//         },
//         standard: {
//           week1: 1.6,
//           week2: 1.8,
//           week3: 1.4,
//           week4: 1.4,
//         },
//         heavy: {
//           week1: 1.8,
//           week2: 2,
//           week3: 1.6,
//           week4: 1.6,
//         },
//       },
//     },
//     PRODUCTS: {
//       katana_roots: {
//         label: "Katana Roots",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 0.2, week2: 0.2, week3: 0.2 },
//         floweringGrowth: {},
//       },
//       zenzym: {
//         label: "Zenzym",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: 2.5, week2: 2.5, week3: 2.5 },
//         floweringGrowth: {
//           week1: 2.5,
//           week2: 2.5,
//           week3: 2.5,
//           week4: 2.5,
//           week5: 2.5,
//         },
//       },
//       silicon: {
//         label: "Shogun Silicon",
//         conductivity: 0.1,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: null,
//         },
//       },
//       calmag: {
//         label: "Shogun CalMag",
//         conductivity: 0.35,
//         vegetativeGrowth: { week1: 1, week2: 1, week3: 1 },
//         floweringGrowth: {
//           week1: 1,
//           week2: 1,
//           week3: 1,
//           week4: 1,
//           week5: null,
//         },
//       },
//       sumo_active_boost: {
//         label: "Sumo Active Boost",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: null, week3: null },
//         floweringGrowth: {
//           week1: 2.0,
//           week2: 2.0,
//           week3: 2.0,
//           week4: 2.0,
//           week5: 2.0,
//         },
//       },
//       sumo_active_foliar: {
//         label: "Sumo Active Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: { week1: null, week2: 2.0, week1: null },
//         floweringGrowth: {
//           week1: 2.0,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//         },
//       },
//       geisha_foliar: {
//         label: "Geisha Foliar",
//         conductivity: 0.0,
//         vegetativeGrowth: {
//           week1: null,
//           week2: "RTU",
//           week3: null,
//           week4: "RTU",
//         },
//         floweringGrowth: {
//           week1: "RTU",
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: null,
//           week6: null,
//           week7: null,
//           week8: null,
//         },
//       },
//       pk_warrior: {
//         label: "PK Warrior 9/18",
//         conductivity: 0.5,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: 0.5,
//           week2: 0.5,
//           week3: 0.5,
//           week4: 0.5,
//           week5: null,
//         },
//       },
//       dragon_force: {
//         label: "Dragon Force",
//         conductivity: 0.3,
//         vegetativeGrowth: {},
//         floweringGrowth: {
//           week1: null,
//           week2: null,
//           week3: null,
//           week4: null,
//           week5: 4,
//         },
//       },
//     },
//   },
// };

/* ==============================
   HELPERS
============================== */
function formatFeedValue(value, tankSize) {
  if (value === null || isNaN(value)) return value;
  
  let rounded;
  if (tankSize <= 10) {
    // Round to nearest 0.5
    rounded = Math.round(value * 2) / 2;
  } else if (tankSize <= 100) {
    // Round to nearest whole number
    rounded = Math.round(value);
  } else {
    // Round to nearest 5
    rounded = Math.round(value / 5) * 5;
  }
  
  // Delete trailing zeros: convert to number to drop .00, then to string
  return Number(rounded.toFixed(2)).toString();
}


// clear result Table values 
function clearResultTableValues() {
  const table = document.getElementById("resultsTable");
  if (!table) return;

  table.querySelectorAll("tbody tr").forEach(function (tr) {
    Array.from(tr.children).forEach(function (td, index) {
      // Skip labels (column 0) OR clear generated values in any column
      if (index === 0 && (!td.dataset.generated || td.dataset.generated !== "true")) {
        return; // Keep static labels in first column
      }
      
      // Clear any generated content
      if (td.dataset.generated === "true") {
        td.textContent = "";
      }
    });
  });
}


// Base rows start 
function getBaseStartValue(baseKey, conductivityKey) {
  const base = START_FEED_CONDUCTIVITY[baseKey]?.[conductivityKey];

  // Coco or old structure
  if (typeof base === "number") return base;

  // Hydro / Terra with Start
  if (typeof base === "object" && base.start != null) {
    return base.start;
  }

  return 0;
}

// Nutrient Key
function normalizeNutrientKey(value) {
  if (!value) return "";

  return value
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_") // spaces → _
    .replace(/-+/g, "_"); // hyphens → _
}
function normalizeBaseKey(baseTitle) {
  const t = baseTitle.toLowerCase();

  if (t.includes("grow") && t.includes("a")) return "Grow_A";
  if (t.includes("grow") && t.includes("b")) return "Grow_B";

  if (t.includes("bloom") && t.includes("a")) return "Bloom_A";
  if (t.includes("bloom") && t.includes("b")) return "Bloom_B";

  if (t.endsWith(" a")) return "A";
  if (t.endsWith(" b")) return "B";

  return null;
}

function isHydroSelected(selectedValue) {
  return selectedValue.toLowerCase().includes("hydro");
}
function getBaseFeedKey(nutrientLineKey) {
  if (!nutrientLineKey) return "coco";

  // ---- HYDRO ----
  // if (nutrientLineKey.startsWith("hydro_hw")) {
  //   return nutrientLineKey.includes("auto") ? "hydro_hw_auto" : "hydro_hw";
  // }

  if (nutrientLineKey.startsWith("hydro")) {
    return nutrientLineKey.includes("auto") ? "hydro_auto" : "hydro";
  }

  // ---- TERRA ----
  if (nutrientLineKey.startsWith("terra")) {
    return nutrientLineKey.includes("auto") ? "terra_auto_all_mix" : "terra_all_mix";
  }

  // ---- COCO ----
  if (nutrientLineKey.includes("auto")) {
    return "coco_auto";
  }

  return "coco";
}

function updateBaseRows(baseKey) {
  const rows = document.querySelectorAll(".base-row");

  const feeds = BASE_FEEDS[baseKey] || [];
  const conductivityMap = BASE_FEED_CONDUCTIVITY[baseKey] || {};

  const startActive =
    document.querySelector("#startPhase")?.checked ||
    document.querySelector(".start-row")?.classList.contains("active");
    const isHydroOrTerra = baseKey.includes("hydro") || baseKey.includes("terra");

    rows.forEach((row, index) => {
    const cells = row.querySelectorAll("td");

    
    const baseTitle = feeds[index];
    const titleEl = row.querySelector(".base-title");

    if (!baseTitle) {
      row.style.display = "none";
      row.dataset.conductivity = 0;
      return;
    }

    row.style.display = "";
    titleEl.textContent = baseTitle;

    /* NORMAL BASE LOGIC */
    const conductivityKey = normalizeBaseKey(baseTitle);
    const conductivity = conductivityMap[conductivityKey] ?? row.dataset.conductivity ?? 0;

    row.dataset.conductivity = conductivity;

    /* Cache normal values once */
    if (!cells[1]?.dataset.normal) {
      cells[1].dataset.normal = cells[1].textContent.trim();
    }
    if (!cells[2]?.dataset.normal) {
      cells[2].dataset.normal = cells[2].textContent.trim();
    }

    /* START PHASE — Hydro & Terra only */
    if (isHydroOrTerra && conductivityKey?.startsWith("Grow")) {
      !startActive ? (cells[1].textContent = "1") : (cells[1].textContent = "");

      !startActive ? (cells[2].textContent = "1") : (cells[2].textContent = "");
    } else {
      !startActive ? (cells[1].textContent = "1") : (cells[1].textContent = "");

      !startActive ? (cells[2].textContent = "1") : (cells[2].textContent = "");
    }
  });
}

const nutrientSelect = document.querySelector("#nutrientSelect");
const nutrientKey = normalizeNutrientKey(
  document.querySelector("#nutrientSelect")?.value,
);

if (nutrientSelect) {
  updateBaseRows(nutrientSelect.value);

  nutrientSelect.addEventListener("change", (e) => {
    updateBaseRows(e.target.value);
    
  });
}
// 
function applyAutoWeekSequence(isAuto) {
  let i = 1;
  let j = 1;
  let k = 1;
  // Body cells
  if(isAuto){
    document.querySelectorAll(`#resultsTable thead tr.week-heading th`).forEach((th, index) => {
      if(!AUTO_HIDE_WEEKS.includes(th.dataset.week)){
          th.textContent = isAuto ? i++ : "";
      }
    });
  } else {
    document.querySelectorAll(`#resultsTable thead tr.week-heading th`).forEach((th, index) => {
      if(index < 2 ){
          th.textContent = i++;
      }
      if(index >= 2 && index <= 5){
          th.textContent = j++;
      }
      if(index >= 6){
          th.textContent = k++;
      }
    });
  }
  
}
function applyAutoWeekVisibility(isAuto) {
  AUTO_HIDE_WEEKS.forEach((week) => {
    const colIndex = getColumnIndex(week);
    if (colIndex === -1) return;

    // Header
    document
      .querySelectorAll(`[data-week="${week}"]`)
      .forEach((th) => (th.style.display = isAuto ? "none" : ""));

    // Body cells
    document.querySelectorAll(`#resultsTable tbody tr`).forEach((tr) => {
      const td = tr.children[colIndex - 1];
      if (td) td.style.display = isAuto ? "none" : "";
    });
  });
}

function getColumnIndex(week) {
  const ths = document.querySelectorAll("#resultsTable thead tr:last-child th");

  for (let i = 0; i < ths.length; i++) {
    if (ths[i].dataset.week === week) {
      return i + 2; // +2 = Product + Dilution columns
    }
  }
  return -1;
}
function isAutoNutrient(value) {
  return value && value.includes("auto");
}

document.addEventListener("DOMContentLoaded", () => {
  const nutrientSelect = document.querySelector("#nutrientSelect");
  const startCheckbox = document.querySelector("#startPhase");

  const updateAll = () => {
    const baseKey = nutrientSelect?.value;
    if (!baseKey) return;

    updateBaseRows(baseKey); // 🔑 THIS WAS MISSING
  };

  const isAuto = isAutoNutrient(nutrientSelect?.value);
  applyAutoWeekVisibility(isAuto);
  applyAutoWeekSequence(isAuto);
  applyAutoHeaderColspan(isAuto);

  nutrientSelect?.addEventListener("change", (e) => {
    const auto = isAutoNutrient(e.target.value);
    const nutrientLineKey = normalizeNutrientKey(e.target.value);
    applyAutoWeekVisibility(auto);
     applyAutoWeekSequence(isAuto);
    // updateWeekHeaders(nutrientLineKey);
    applyAutoHeaderColspan(auto);
    updateAll(); // ✅ re-render on nutrient change
   
  });

  startCheckbox?.addEventListener("change", () => {
    updateAll(); // ✅ re-render on Start toggle
 
  });
});

function applyAutoHeaderColspan(isAuto) {
  const headerRow = document.querySelector(
    "#resultsTable thead tr:first-child",
  );
  if (!headerRow) return;

  const ths = headerRow.children;

  /*
    Index reference:
    0 = Product
    1 = Cuttings
    2 = Veg
    3 = Flower
    4 = Final Week
  */

  if (isAuto) {
    ths[1].setAttribute("colspan", "1"); // Cuttings
    ths[2].setAttribute("colspan", "3"); // Veg
    ths[3].setAttribute("colspan", "5"); // Flower
  } else {
    ths[1].setAttribute("colspan", "2"); // Cuttings
    ths[2].setAttribute("colspan", "4"); // Veg
    ths[3].setAttribute("colspan", "8"); // Flower
  }
}

function isRowDisabledByLabel(productLabel) {
  const row = getRowByProductName(productLabel);

  return row ? row.classList.contains("row-disabled") : false;
}
document.addEventListener("change", (e) => {
  const checkbox = e.target.closest(".row-toggle input");
  if (!checkbox) return;

  const row = checkbox.closest("tr");
  const productKey = row?.dataset.product || "unknown";

  document.getElementById("generateBtn").click();
});

function getFeedingKey(value) {
  if (value === "light_feeding") return "light";
  if (value === "heavy_feeding") return "heavy";
  return "standard";
}

function getWaterECFromForm(form) {
  const selected = form.water_type.value;
  const manual = Number(form.hardness.value);
  // return selected === "?" ? manual || 0 : Number(selected || 0);
  return manual;
}

/* KEEP WATER → HARDNESS SYNC */
function bindWaterSync() {
  const waterSelect = document.getElementById("waterType");
  const hardnessInput = document.getElementById("hardnessValue");

  waterSelect.addEventListener("change", function () {
    if (this.value !== "?") {
      hardnessInput.value = this.value;
    }
  });
}

function getRowByProductName(name) {
  return [...document.querySelectorAll("#resultsTable tbody tr")].find(
    (tr) => tr.querySelector(".title")?.textContent.trim() === name,
  );
}

function isStartDisabled() {
  const row = getRowByProductName("Start");
  return row ? row.classList.contains("row-disabled") : false;
}

function isStartOff() {
  const startRow = [
    ...document.querySelectorAll("#resultsTable tbody tr"),
  ].find((tr) => tr.querySelector(".title")?.textContent.trim() === "Start");
  if (!startRow) return false;

  const toggle = startRow.querySelector(".toggle-row");
  return toggle ? !toggle.checked : false;
}
function applyCocoMinValues() {
  const MIN_VALUE = 1; // 1 mL minimum
  const cocoRows = ["Samurai Coco A", "Samurai Coco B"];

  cocoRows.forEach((name) => {
    const row = [...document.querySelectorAll("#resultsTable tbody tr")].find(
      (tr) => tr.querySelector(".title")?.textContent.trim() === name,
    );

    if (!row) return;

    // Cuttings & Seedlings are columns 1 and 2 (index 1 and 2)
    for (let col = 1; col <= 2; col++) {
      if (isStartOff()) {
        // Start is OFF → force minimum
        row.children[col].textContent = MIN_VALUE;
      } else {
        // Start is ON → clear the 1 if it was previously set
        row.children[col].textContent = "-";
      }
    }
  });
}

function getPhaseFromLabel(label) {
  const lower = label.toLowerCase();

  if (lower.includes("grow")) return "grow";
  if (lower.includes("bloom")) return "bloom";

  return "base"; // fallback for coco, etc.
}
function isPhaseBasedNutrient(nutrientKey) {
  return PHASE_BASED_NUTRIENTS.includes(nutrientKey);
}

function addToFinalEC({ row, productEC, nutrientKey, finalEC }) {
  // NON phase-based (true coco only)
  if (!isPhaseBasedNutrient(nutrientKey)) {
    finalEC.base += productEC;
    return;
  }

  let phase = getPhaseFromLabel(row.children[0].textContent);

  // 🌱 Terra fallback
  if (phase === "base" && nutrientKey.startsWith("terra")) {
    phase = "grow"; // Terra additives follow grow by default
  }

  if (finalEC[phase] !== undefined) {
    finalEC[phase] += productEC;
  }
}

/* ==============================
   EC CALCULATIONS
============================== */

function calculateProductEC(weekValue, product) {
  if (!weekValue || product.conductivity === 0) return 0;

  return weekValue * product.conductivity;
}

function calculateVegEC(weekKey, waterEC, feedingKey) {
  let nutrientEC = 0;
  let removedECLog = [];

  Object.values(PRODUCTS).forEach((product) => {
    // 1️⃣ If row disabled → product does not exist
    if (isRowDisabledByLabel(product.label)) {
      return;
    }
    // 2️⃣ Now safely read week value
    const weekValue = product.vegetativeGrowth?.[weekKey];
    if (!weekValue) return;
    // 3️⃣ Calculate EC    
    if(Number(weekValue) > 0 ){
      let productConductivity = product.conductivity;
      let newWeekValue = weekValue;
      if(product.label == "Shogun CalMag"){
         if (waterEC < 0.4) {
            newWeekValue = 1.0;
          } else if (waterEC <= 0.55) {
          
            newWeekValue = 0.5;
          } else {
            newWeekValue = 0.0;
          }
      }
     const productEC = newWeekValue * productConductivity;
     nutrientEC += productEC;
    } else {
      nutrientEC += 0;
    }
  });

  // nutrientEC = +nutrientEC.toFixed(2);
  nutrientEC = nutrientEC
  // const totalEC = +(nutrientEC + waterEC).toFixed(2);
  const totalEC = nutrientEC + waterEC;
  const targetEC = TARGET_EC.vegetative[feedingKey][weekKey];
  // const availableEC = +(targetEC - totalEC).toFixed(2);
  const availableEC = targetEC - totalEC;
  console.log('availableEC', availableEC, 'totalEC', totalEC)
  return { targetEC, nutrientEC, totalEC, availableEC };
}

function calculateFlowerEC(weekKey, waterEC, feedingKey) {
  let nutrientEC = 0;

  Object.values(PRODUCTS).forEach((product) => {
    // Skip disabled rows
    if (isRowDisabledByLabel(product.label)) {
      return;
    }

    const weekValue = product.floweringGrowth?.[weekKey];
    if (weekValue == null) return;
    if(Number(weekValue) > 0 ){
     let productConductivity = product.conductivity;
      let newWeekValue = weekValue;
      if(product.label == "Shogun CalMag"){
         if (waterEC < 0.4) {
            newWeekValue = 1.0;
          } else if (waterEC <= 0.55) {
          
            newWeekValue = 0.5;
          } else {
            newWeekValue = 0.0;
          }
      }

     const productEC = newWeekValue * productConductivity;
     nutrientEC += productEC;
    } else {
      nutrientEC += 0;
    }
  });

  // nutrientEC = +nutrientEC.toFixed(2);
  nutrientEC = nutrientEC;
  // const totalEC = +(nutrientEC + waterEC).toFixed(2);
  const totalEC = nutrientEC + waterEC;
  const targetEC = TARGET_EC.flowering[feedingKey][weekKey];
  if (targetEC == null) return;
  // const availableEC = +(targetEC - totalEC).toFixed(2);
  const availableEC = targetEC - totalEC;
  return { targetEC, nutrientEC, totalEC, availableEC };
}

function updateBaseFeedValues({ columnIndex, availableEC, tankSize, baseKey }) {
  if (!availableEC || availableEC <= 0) return;

  const baseFeeds = BASE_FEEDS[baseKey];
 
  if (!baseFeeds?.length) return;
  // 1️⃣ Collect base rows + their conductivities
  const columnPhase = getPhaseFromColumnIndex(columnIndex);
  const baseRows = baseFeeds
    .map((name) => getRowByProductName(name))
    .filter((row) => {
      if (!row) return false;

      // Coco → allow all
      if (!isPhaseBasedNutrient(baseKey)) return true;

      // Hydro / Terra → phase match
      const rowPhase = getPhaseFromLabel(
        row.querySelector(".base-title")?.textContent || "",
      );

      return rowPhase === columnPhase;
    });

  if (!baseRows.length) return;

  // 2️⃣ Calculate total conductivity weight
  const totalConductivity = baseRows.reduce((sum, row) => {
    return sum + Number(row.dataset.conductivity || 0);
  }, 0);
  if (totalConductivity <= 0) return;

  // 3️⃣ Distribute EC proportionally
  baseRows.forEach((row) => {
    const conductivity = Number(row.dataset.conductivity || 0);

    if (!conductivity) return;

    // 🔒 PHASE SAFETY CHECK
    if (isPhaseBasedNutrient(baseKey)) {
      const columnPhase = getPhaseFromColumnIndex(columnIndex);
      const rowPhase = getPhaseFromLabel(
        row.querySelector(".base-title")?.textContent || "",
      );

      // ❌ Skip if phase does not match
      if (rowPhase !== columnPhase) return;
    }

    const productECShare = availableEC * (conductivity / totalConductivity);
    // const productECShare =
    const ml = (productECShare / conductivity) * tankSize;
    // row.children[columnIndex].textContent = Math.max(0, ml.toFixed(2));
        row.children[columnIndex].textContent = formatFeedValue(ml, tankSize);
    

  });
}

function getPhaseFromColumnIndex(columnIndex) {
  // Veg columns: 3–6
  if (columnIndex >= 3 && columnIndex <= 6) {
    return "grow";
  }

  // Flower columns: 7–14
  if (columnIndex >= 7 && columnIndex <= 14) {
    return "bloom";
  }

  return null;
}

/* ==============================
   COCO A & B
============================== */

function calculateCocoAB(availableEC, tankSize) {
  const COCO_CONDUCTIVITY = 0.25;
  if (availableEC <= 0) return { cocoA: 0, cocoB: 0 };

  const mlEach = (availableEC / COCO_CONDUCTIVITY / 2) * tankSize;

  return {
    cocoA: +mlEach.toFixed(2),
    cocoB: +mlEach.toFixed(2),
  };
}

/* ==============================
   TABLE UPDATES
============================== */

/* Target Conductivity row */

function updateTargetConductivityRow(feedingKey) {
  if (!TARGET_EC?.vegetative?.[feedingKey]) return;

  const row = document.querySelector(".target-row");
  if (!row) return;

  const cells = row.children;

  /* -------------------------------
     VEGETATIVE GROWTH (W1–W4)
  -------------------------------- */

  ["week1", "week2", "week3", "week4"].forEach((week, i) => {
    cells[3 + i].textContent = TARGET_EC.vegetative[feedingKey][week] ?? "-";
  });

  /* -------------------------------
     FLOWERING GROWTH (W1–W8)
     (leave existing values if already working)
  -------------------------------- */
  const FLOWER_WEEKS = [
    "week1",
    "week2",
    "week3",
    "week4",
    "week5",
    "week6",
    "week7",
    "week8",
  ];
  FLOWER_WEEKS.forEach((week, i) => {
    cells[7 + i].textContent = TARGET_EC.flowering[feedingKey][week];
  });
}

/* ==============================
   DOM READY
============================== */
document.addEventListener("DOMContentLoaded", () => {
  const tableWrapper = document.querySelector("#feedTableWrapper");
  const calculator = document.querySelector("#feedCalculator");
  const form = document.getElementById("feedCalculator");
  const generateBtn = document.getElementById("generateBtn");


  // Form Validation 
  function isFormValid() {
    const nutrient = document.getElementById('nutrientSelect');
    const tankSize = document.getElementById('tankSize');
    const water    = document.getElementById('hardnessValue');
    const feeding  = document.getElementById('feeding');

    if (!nutrient || !tankSize || !water || !feeding) return false;

    if (!nutrient.value) return false;
    if (!tankSize.value || Number(tankSize.value) <= 0) return false;
    if (!water.value) return false;
    if (!feeding.value) return false;

    return true;
  }

  if (!calculator) return;
// Initial state
  updateGenerateButtonState();
  calculator.addEventListener('input', function () {
    updateGenerateButtonState();
    
  });

  calculator.addEventListener('change', function () {
    updateGenerateButtonState();
  });

  bindWaterSync();

  // update generate button state 
  function updateGenerateButtonState() {
    const generateBtn = document.getElementById('generateBtn');
    if (!generateBtn) return;

    generateBtn.disabled = !isFormValid();
  }

  // Show Result Table
  function showResultsTable() {
    if (!tableWrapper) return;
    tableWrapper.classList.remove("hidden");
  }

// Hide and reset Result table data 
  function hideAndResetResultsTable() {
    if (!tableWrapper) return;

    clearResultTableValues();
    tableWrapper.classList.add("hidden");
  }
  if (generateBtn) {
    generateBtn.addEventListener("click", function (e) {
      e.preventDefault();
      showResultsTable();
    });
  }
// get form summary
//   function renderFormSummary() {
//   const nutrient = document.getElementById('nutrientSelect');
//   const tankSize = document.getElementById('tankSize');
//   const unitType = document.getElementById('unitType');
//   const feeding  = document.getElementById('feeding');
//   const water    = document.getElementById('hardnessValue');
//   const units    = document.getElementById('unitType');
//   const summary  = document.getElementById('formSummary');

//   if (!summary) return;

//   const productLine   = nutrient ? nutrient.value : '';
//   const tankValue     = tankSize ? tankSize.value : '';
//   const tankUnit      = unitType ? unitType.value : '';
//   const feedingText   = feeding ? feeding.options[feeding.selectedIndex].text : '';
//   const waterValue    = water ? water.value : '';
//   const dosageUnits   = 'mL / Litres'; // static (can be dynamic later)
//   const recommendedPH = '5.5 - 6.0';      // static (based on nutrient line)

//   summary.innerHTML =
//     '<strong>Product Line:</strong> ' + productLine + '<br>' +
//     '<strong>Tank Size:</strong> ' + tankValue + ' ' + tankUnit + '<br>' +
//     '<strong>Scheduled Type:</strong> ' + feedingText + '<br>' +
//     '<strong>Water:</strong> ' + waterValue + ' EC<br>' +
//     '<strong>Dosage Units:</strong> ' + dosageUnits + '<br>' +
//     '<strong>Recommended pH:</strong> ' + recommendedPH;

//   summary.classList.remove('hidden');
// }


function renderFormSummary() {
  const nutrient = document.getElementById('nutrientSelect');
  const tankSize = document.getElementById('tankSize');
  const unitType = document.getElementById('unitType');
  const feeding  = document.getElementById('feeding');
  const water    = document.getElementById('hardnessValue');
  const summary  = document.getElementById('formSummary');

  if (!summary) return;

  const labels = window.FEED_CHART_LABELS || {};

  const productLine   = nutrient ? nutrient.value : '';
  const tankValue     = tankSize ? tankSize.value : '';
  // const tankUnit      = unitType ? unitType.value : '';
  const tankUnit      = unitType ? unitType.options[unitType.selectedIndex]?.text : '';
  const feedingText   = feeding ? feeding.options[feeding.selectedIndex].text : '';
  const waterValue    = water ? water.value : '';
  const dosageUnits   = labels.summary_dosage_units || 'mL / Litres';
  const recommendedPH = labels.summary_ph_value     || '5.5 - 6.0';

  summary.innerHTML =
    '<strong>' + (labels.summary_product_line || 'Product Line')   + ':</strong> ' + productLine + '<br>' +
    '<strong>' + (labels.summary_tank         || 'Tank Size')       + ':</strong> ' + tankValue + ' ' + tankUnit + '<br>' +
    '<strong>' + (labels.summary_schedule     || 'Scheduled Type')  + ':</strong> ' + feedingText + '<br>' +
    '<strong>' + (labels.summary_water        || 'Water')           + ':</strong> ' + waterValue + ' EC<br>' +
    '<strong>' + (labels.summary_dosage       || 'Dosage Units')    + ':</strong> ' + dosageUnits + '<br>' +
    '<strong>' + (labels.summary_ph           || 'Recommended pH')  + ':</strong> ' + recommendedPH;

  summary.classList.remove('hidden');
}

// hide form summary
function hideFormSummary() {
  const summary = document.getElementById('formSummary');
  if (summary) summary.classList.add('hidden');
}

// information div show/hide
const infoBtn = document.getElementById("infoBtn");
  const popup = document.getElementById("infoPopup");
  const closePopup = document.getElementById("closePopup");

  infoBtn.addEventListener("click", () => {
    popup.style.display = "flex";
    if (calculator) calculator.style.display = "none";
    if (tableWrapper) tableWrapper.style.display = "none";
  });

  closePopup.addEventListener("click", () => {
    popup.style.display = "none";
    if (calculator) calculator.style.display = "";
    if (tableWrapper) tableWrapper.style.display = "";
  });

  // Close when clicking outside popup
  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.style.display = "none";
      if (calculator) calculator.style.display = "";
    }
  });


  // Update CalMAG week values as per water type
 function applyCalMagOverrideIfNeeded(isAuto) {
  const waterEC = Number(document.querySelector('#hardnessValue')?.value);
  if (Number.isNaN(waterEC)) return;

  const tankSize = oldTankSize;

  let ratePerLiter;
  if (waterEC < 0.4) {
    ratePerLiter = 1.0;
  } else if (waterEC <= 0.55) {
   
    ratePerLiter = 0.5;
  } else {
    ratePerLiter = 0.0;
  }

  const finalValue = ratePerLiter * tankSize;
  document.querySelectorAll('#resultsTable tbody tr').forEach(row => {
    if (row.dataset.product !== 'calmag') return;

    row.querySelectorAll('td').forEach((cell, index) => {
      if (index < 3) return;
      if(isAuto && index > 10) {
        return;
      } else if(!isAuto && index > 13){
        return;
      }
      // cell.textContent = ratePerLiter === 0 ? '0' : finalValue;
      cell.textContent = ratePerLiter === 0 ? '0' : formatFeedValue(finalValue, tankSize);
    });
  });
}

  // Updating week values as per Tank size(multiple week values with tank size)
function updateTableByTankSize(newTankSize) {
  const rows = document.querySelectorAll("#resultsTable tbody tr");
  const nutrientLineKey = document.querySelector('#nutrientSelect')?.value?.toLowerCase().replace(/g/, '') || '';
  const feedingKey = getFeedingKey(document.querySelector('#feeding')?.value);
  const waterEC = document.querySelector('#hardnessValue')?.value === '?' ? 0 : Number(document.querySelector('#hardnessValue')?.value) || 0;
  const baseKey = getBaseFeedKey(nutrientLineKey);

  // Step 1: Update additives first (Katana Roots + base cache)
  rows.forEach(row => {
    if (row.classList.contains("row-disabled")) return;
    // if (row.dataset.product === 'sumo_active_foliar') return;

    const productKey = row.dataset.product;
    
    const cells = row.querySelectorAll("td");
    
    
    cells.forEach((cell, index) => {
      
      // ⛔ Always skip product name
      if (index === 0) return;

      // ⛔ Skip cutting & seedling for ALL except Katana Roots
      if (index < 3 && (productKey !== 'katana_roots' && productKey !== 'shougan_start' )) return;
      let defaultValue = null;
      let weekKey = null;
      
      if (productKey === 'shougan_start' && (index === 1)) {
        defaultValue = START_FIXED_WEEKS.seedlings.week1;
        console.log('defaultValue',defaultValue)
      }
      if (productKey === 'shougan_start' && (index === 2)) {
        defaultValue = START_FIXED_WEEKS.seedlings.week2;
      }
      // ✅ Katana Roots: cutting & seedling
      if (productKey === 'katana_roots' && (index === 1 || index === 2)) {
        defaultValue = 5;
      }
      // ✅ Veg weeks
      else if (index >= 3 && index <= 6) {
        weekKey = `week${index - 2}`;
      }
      // ✅ Flower weeks
      else if (index >= 7) {
        weekKey = `week${index - 6}`;
      }

      if (weekKey && PRODUCTS?.[productKey]) {
        const vegVal = (index >= 3 && index <= 6) ? PRODUCTS[productKey].vegetativeGrowth?.[weekKey] : null ;
        const flowerVal = (index >= 7) ? PRODUCTS[productKey].floweringGrowth?.[weekKey] : null;
      

        if(vegVal && !(Number(vegVal) > 0)) {
          cell.textContent = vegVal;
          return;
        }
        if(flowerVal && !(Number(flowerVal) > 0)) {
          cell.textContent = flowerVal;
          return;
        }

        
        if (vegVal) {
          defaultValue = parseFloat(vegVal);
        } else if (flowerVal) {
          defaultValue = parseFloat(flowerVal);
        }
      } else {
        const normalValue = cell.dataset.normal;
        if (normalValue) defaultValue = parseFloat(normalValue);
      }

      if (!defaultValue || Number.isNaN(defaultValue)) return;

      // cell.textContent = (defaultValue * newTankSize).toFixed(1);
//      cell.textContent = (
//   defaultValue *
//   (productKey === 'sumo_active_foliar' ? 1 : newTankSize)
// ).toFixed(2).replace(/\.?0+$/, '');
    //  cell.textContent = (defaultValue * newTankSize).toFixed(2).replace(/\.?0+$/, '');
    cell.textContent = formatFeedValue(defaultValue * newTankSize, newTankSize);
      if (!productKey) {
        cell.dataset.normal = defaultValue.toString();
      }
      console.log('cell.textContent', cell.textContent)
    });
    
  });

  // Step 2: Recalculate base rows to hit TARGET EC
  const VEGWEEKS = nutrientLineKey.includes('auto') ? ['week1','week2','week3'] : ['week1','week2','week3','week4'];
  const FLOWERWEEKS = nutrientLineKey.includes('auto')
    ? ['week4','week5','week6','week7','week8']
    : ['week5','week6','week7','week8','week9','week10','week11','week12'];


  // Vegetative weeks (columns 3-6)
  VEGWEEKS.forEach((weekKey, i) => {
    const veg = calculateVegEC(weekKey, waterEC, feedingKey);
    if (veg) {
      const columnIndex = nutrientLineKey.includes('auto') ? 3 + i : 6 - i; // Adjust column mapping
      updateBaseFeedValues(columnIndex, veg.availableEC, newTankSize, baseKey);
    }
  });

  // Flowering weeks (columns 7+)
    FLOWERWEEKS.forEach((weekKey) => {
      const flower = calculateFlowerEC(weekKey, waterEC, feedingKey);
      if (!flower) return;

      const columnIndex = Number(weekKey.replace('week', ''));
      // IMPORTANT: only recalc BASE feed rows
      updateBaseFeedValues(columnIndex, flower.availableEC, newTankSize, baseKey, {
        skipNonBase: true
      });
    });

}




// make my chart button code to generate Result data
  generateBtn.addEventListener("click", () => {
    function createFinalEC(nutrientKey) {
      return isPhaseBasedNutrient(nutrientKey)
        ? { grow: 0, bloom: 0 }
        : { base: 0 };
    }
    const nutrientLineKey = form.nutrient_line.value
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");
    const lineConfig = NUTRIENT_LINES[nutrientLineKey];
    if (!lineConfig) {
      console.error("Unknown nutrient line:", nutrientLineKey);
      return;
    }
    TARGET_EC = lineConfig.TARGET_EC;
    PRODUCTS = lineConfig.PRODUCTS;

    const feedingKey = getFeedingKey(form.feeding.value);
    
    const waterEC = getWaterECFromForm(form);
    const tankSize = Number(form.tankSize.value) || TANKSIZE;
    const scaleFactor = tankSize / oldTankSize;
    oldTankSize = tankSize;
    
    updateTargetConductivityRow(feedingKey);

    let baseKey = getBaseFeedKey(nutrientLineKey);
    updateBaseRows(baseKey);

    const VEG_WEEKS = nutrientLineKey.includes("auto")
      ? ["week1", "week2", "week3"]
      : ["week1", "week2", "week3", "week4"];
    const FLOWER_WEEKS = nutrientLineKey.includes("auto")
      ? ["week1", "week2", "week3", "week4", "week5"]
      : [
          "week1",
          "week2",
          "week3",
          "week4",
          "week5",
          "week6",
          "week7",
          "week8",
        ];
    clearBaseRows([
      "Samurai Coco A",
      "Samurai Coco B",
      "Samurai Hydro Grow A",
      "Samurai Hydro Grow B",
      "Samurai Hydro Bloom A",
      "Samurai Hydro Bloom B",
      "Samurai Terra Grow",
      "Samurai Terra Bloom",
      "Samurai Terra Grow auto",
      "Samurai Terra Bloom auto"     
    ]);

    function clearBaseRows(rowNames) {
      rowNames.forEach((name) => {
        const row = getRowByProductName(name);

        if (!row) return;

        VEG_WEEKS.forEach((_, i) => {
          if (nutrientLineKey.includes("auto")) {
            row.children[parseInt(`${VEG_WEEKS.length}`) + i].textContent = "-";
          } else {
            row.children[parseInt(`${VEG_WEEKS.length - 1}`) + i].textContent =
              "-";
          }
        });

        FLOWER_WEEKS.forEach((_, i) => {
          if (nutrientLineKey.includes("auto")) {
            row.children[
              parseInt(`${FLOWER_WEEKS.length + 2}`) + i
            ].textContent = "-";
          } else {
            row.children[parseInt(`${VEG_WEEKS.length - 1}`) + i].textContent =
              "-";
          }
        });
      });
    }
    VEG_WEEKS.forEach((weekKey, i) => {
      const veg = calculateVegEC(weekKey, waterEC, feedingKey);
      if (!veg) return;

      updateBaseFeedValues({
        columnIndex: nutrientLineKey.includes("auto")
          ? parseInt(`${VEG_WEEKS.length}`) + i
          : parseInt(`${VEG_WEEKS.length - 1}`) + i,
        availableEC: veg.availableEC,
        tankSize,
        baseKey,
      });
    });

    FLOWER_WEEKS.forEach((weekKey, i) => {
      const flower = calculateFlowerEC(weekKey, waterEC, feedingKey);
      if (!flower) return;

      updateBaseFeedValues({
        columnIndex: nutrientLineKey.includes("auto")
          ? parseInt(`${FLOWER_WEEKS.length + 2}`) + i
          : parseInt(`${FLOWER_WEEKS.length - 1}`) + i,
        availableEC: flower.availableEC,
        tankSize,
        baseKey,
      });
    });

    // ==============================
    // FINAL EC CALCULATION (FIXED)
    // ==============================

    const isPhaseBased = isPhaseBasedNutrient(nutrientLineKey);

    let finalEC = isPhaseBased ? { grow: 0, bloom: 0 } : { base: 0 };

    // Only base rows contribute to Final EC
    const baseFeeds = BASE_FEEDS[baseKey] || [];

    baseFeeds.forEach((name) => {
      const row = getRowByProductName(name);
      const isAdditive = row.dataset.type === "additive";

      if (!row || row.classList.contains("row-disabled")) return;

      const conductivity = Number(row.dataset.conductivity || 0);
      if (!conductivity) return;
      const label = row.children[0].textContent.toLowerCase();

      [...row.children].forEach((cell, index) => {
        const ml = parseFloat(cell.textContent);
        
        const ec = ml * conductivity;

        if (!isPhaseBased) {
          finalEC.base += ec;
        } else {
          // Veg columns = 3–6
          // Flower columns = 7–14
          if (index >= 3 && index <= 6 && label.includes("grow")) {
            finalEC.grow += ec;
          }

          if (index >= 7 && index <= 14 && label.includes("bloom")) {
            finalEC.bloom += ec;
          }
        }
      });
    });
    applyCocoMinValues();
    updateBaseRows(baseKey);
    const isAuto = nutrientLineKey.includes("auto");
    applyAutoWeekVisibility(isAuto);
    applyAutoWeekSequence(isAuto);
    updateTableByTankSize(parseFloat(tankSize) || 1);
    applyCalMagOverrideIfNeeded(isAuto);
    applyAutoHeaderColspan(isAuto);
    renderFormSummary();

  });
  
  const feedCalculator = document.getElementById('feedCalculator');
 
  if (!feedCalculator) return;
 
  // Fires on typing, number change, select change, etc.
  feedCalculator.addEventListener('input', function () {
    onFormValueChange();
  });
 
  // Fires on select change, radio, checkbox
  feedCalculator.addEventListener('change', function () {
    onFormValueChange();
  });
  function onFormValueChange(){
    hideAndResetResultsTable();
  }
});
